var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCmsTool)?_c('div',[(_vm.data.name === _vm.ComponentRefNames.MapMarkers)?_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/map/map_ref_section.png"),"alt":"Karte mit Markers Bild"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }